const prefix = 'SPACE/';

export const SPACE_PROCESSING = `${prefix}SPACE_PROCESSING`;
export const RESET_LOADING = `${prefix}RESET_LOADING`;
export const SET_LOADING = `${prefix}SET_LOADING`;
